import React, { useEffect } from "react";
import Header from "../layouts/Header";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import UnderConstructionComp from "../components/UnderConstructionComp/UnderConstructionComp";
import Footer from "../layouts/Footer";

const UnderConstruction = () => {
  useEffect(() => {
    document.title = "Under Development | TZ Creation";
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <Breadcrumb parentpageName="Home" currentPageName="Available Soon" />
      <UnderConstructionComp />
      <Footer />
    </>
  );
};

export default UnderConstruction;
